import { render } from "./App.vue?vue&type=template&id=2b521a7d&ts=true"
import script from "./App.ts?vue&type=script&lang=ts"
export * from "./App.ts?vue&type=script&lang=ts"

import "./App.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/codebuild/output/src1727934276/src/codestar-connections.eu-central-1.amazonaws.com/git-http/030462892321/eu-central-1/15b42165-810b-4985-ad62-7e8e7752e7c2/studyportals/BodiesEditor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__